const ERROR_ROUTE_PATH = "/error";

const buildErrorLocation = ({ code = "ERROR", reason = "" } = {}) => ({
    path: ERROR_ROUTE_PATH,
    query: {
        code,
        ...(reason ? { reason } : {})
    }
});

const redirectToError = (router, options = {}) => {
    if (!router) return;

    const currentPath = router.currentRoute?.value?.path;

    if (currentPath === ERROR_ROUTE_PATH) return;

    router.replace(buildErrorLocation(options)).catch(() => {});
};

export { ERROR_ROUTE_PATH, buildErrorLocation, redirectToError };
